import { render } from "./mode.vue?vue&type=template&id=04287270"
import script from "./mode.vue?vue&type=script&lang=js"
export * from "./mode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__